import React from "react";

const CardInterest2 = ({
  width,
  height,
  marginLeft,
  marginBottom = 40,
  data,
  borderRadius,
  padding = 0,
}) => {
  //   var result = text.slice(0, count) + (text.length > count ? "..." : "");
  return (
    <div
      className="nib-box interest-box card-interest2"
      style={{
        width,
        // height, // Let height be determined by content
        marginLeft,
        marginBottom,
        borderRadius: borderRadius || "12px",
        padding: padding || "8px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#333",
        boxSizing: "border-box",
      }}
    >
      {/* Image container */}
      <div
        style={{
          width: "100%",
          height: 132,
          marginBottom: "8px",
        }}
      >
        <img
         className="myinterestimg"
          src={
            data?.category_image ||
            "https://bgz-business.s3.us-east-2.amazonaws.com/FreeBusinessImage.jpg"
          }
          // style={{
          //   width: "132px",
          //   height: "132px",
          //   objectFit: "cover",
          //   borderRadius: borderRadius || "12px",
          //   display: "block",
          // }}
          alt={""}
        />
      </div>

      {/* Text container - below image */}
      <div
        className="text-center mt-1 interest_text_container"
        style={{
          width: "100%", // Full width
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          flexGrow: 1,
          // paddingBottom: "8px",
          // minHeight: "40px",
        }}
      >
        {/* Category Name */}
        <h6
          className="text-white interest_category_name"
          style={{
            margin: "0 0 4px 0",
            fontSize: "0.85rem",
            lineHeight: "1.3",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            whiteSpace: "normal",
            textAlign: "center",
            width: "100%",
          }}
        >
          {data?.category_name || ""}
        </h6>
      </div>
    </div>
  );
};

export default CardInterest2;
